<div
  class="gold-upgrade-container horizontal-center back-btn"
  (click)="disabled($event, true)"
  (keydown)="handleKeydown($event)"
  (mousedown)="disabled($event)"
  (mouseup)="disabled($event)"
>
  <app-detail-aha-gold-left-panel></app-detail-aha-gold-left-panel>
  <app-detail-aha-gold-right-panel
    [labelData]="label"
  ></app-detail-aha-gold-right-panel>
</div>
